import type { ReactNode } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/outline";

interface ISidebarSectionProps {
  id: string;
  title: string;
  collapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
}

export const SidebarSection = ({
  id,
  title,
  collapsed,
  onToggle,
  children,
}: ISidebarSectionProps) => {
  const ChevronIcon = collapsed ? ChevronRightIcon : ChevronDownIcon;
  const header = (
    <button
      type="button"
      aria-expanded={!collapsed}
      aria-controls={`sidebar-section-${id}`}
      onClick={onToggle}
      className="flex w-full items-center justify-between text-gray-400 hover:text-white text-sm uppercase cursor-pointer"
    >
      {title}
      <ChevronIcon className="w-4 h-4 stroke-current" />
    </button>
  );
  return (
    <div
      className="
      [@media(max-height:1023px)]:my-1
      [@media(min-height:1024px)]:my-2"
    >
      <div className="divide-y">
        {header}
        <div className="py-1 xxl:mt-1"></div>
      </div>
      <div id={`sidebar-section-${id}`} hidden={collapsed}>
        {children}
      </div>
    </div>
  );
};
